import React, { createContext, useContext, useState, useCallback } from 'react';

// Create context for sharing pricing data
const PricingContext = createContext();

export const PricingProvider = ({ children }) => {
  const [pricingData, setPricingData] = useState({});
  const [loadingItems, setLoadingItems] = useState(new Set());

  const updatePricing = useCallback((productId, pricing, quantity) => {
    setPricingData(prev => ({
      ...prev,
      [productId]: { pricing, quantity },
    }));
  }, []);

  const setLoading = useCallback((productId, isLoading) => {
    setLoadingItems(prev => {
      const newSet = new Set(prev);
      if (isLoading) {
        newSet.add(productId);
      } else {
        newSet.delete(productId);
      }
      return newSet;
    });
  }, []);

  const removePricing = useCallback(productId => {
    setPricingData(prev => {
      const newData = { ...prev };
      delete newData[productId];
      return newData;
    });
  }, []);

  return (
    <PricingContext.Provider
      value={{
        pricingData,
        loadingItems,
        updatePricing,
        setLoading,
        removePricing,
      }}
    >
      {children}
    </PricingContext.Provider>
  );
};

export const usePricing = () => {
  const context = useContext(PricingContext);
  if (!context) {
    throw new Error('usePricing must be used within PricingProvider');
  }
  return context;
};
